import React from 'react'
import {AiOutlineHome,AiOutlineUser,AiOutlineBook} from 'react-icons/ai'
import {BiMessageSquareCheck} from 'react-icons/bi'
import {BsBriefcase} from 'react-icons/bs'
import { useState } from 'react'
import './navbar.css'

function Navbar() {
  const [activeNav,setActiveNav] = useState('#');

  return (
    <div>
      <nav>
        <a href='#' onClick={()=>setActiveNav('#')} className={activeNav === '#' ? 'active':''}><AiOutlineHome/></a>
        <a href='#about' onClick={()=>setActiveNav('#about')} className={activeNav === '#about' ? 'active':''}><AiOutlineUser/></a>
        <a href='#experience' onClick={()=>setActiveNav('#experience')} className={activeNav === '#experience' ? 'active':''}><AiOutlineBook/></a>
        <a href='#portfolio' onClick={()=>setActiveNav('#portfolio')} className={activeNav === '#portfolio' ? 'active':''}><BsBriefcase/></a>
        <a href='#contact' onClick={()=>setActiveNav('#contact')} className={activeNav === '#contact' ? 'active':''}><BiMessageSquareCheck/></a>
      </nav>
    </div>
  )
}

export default Navbar